(function googleAnalitycsHelper(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousAnalitycsHelper = global.NewHomeSource.AnalitycsHelper;

  /**
   * @constructs NewHomeSource.AnalitycsHelper
   */
  function AnalitycsHelper() {}

  AnalitycsHelper.getGoogleAnalitycsIdentifier = function getGoogleAnalitycsIdentifier() {
    let id = null;

    if (typeof global.ga !== 'function' || (typeof global.ga.getAll !== 'function' && global.ga)) {
      return id;
    }

    const allGa = global.ga.getAll().filter((element) => element.get('trackingId') === 'UA-40843711-4');

    if (allGa[0]) {
      id = allGa[0].get('name');
    }

    return id;
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.AnalitycsHelper to the previous script.
   */
  AnalitycsHelper.noConflict = function noConflict() {
    global.NewHomeSource.AnalitycsHelper = previousAnalitycsHelper;
    return AnalitycsHelper;
  };

  global.NewHomeSource.AnalitycsHelper = AnalitycsHelper;
}(window));
